
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12 4.5c-4.13579 0-7.5 3.36421-7.5 7.5 0 4.1358 3.36421 7.5 7.5 7.5 4.1358 0 7.5-3.3642 7.5-7.5 0-4.13579-3.3642-7.5-7.5-7.5zm0 1.09756c3.5427 0 6.4024 2.8597 6.4024 6.40244 0 3.5427-2.8597 6.4024-6.4024 6.4024-3.54274 0-6.40244-2.8597-6.40244-6.4024 0-3.54274 2.8597-6.40244 6.40244-6.40244zm0 .91464c-.303 0-.5488.24581-.5488.54878v4.93902c0 .2029.1108.3794.2744.4745l3.9615 2.2866c.2622.1514.5973.0621.7488-.2001.1515-.2623.0622-.5974-.2-.7489l-3.6871-2.1265v-4.62459c0-.30296-.2458-.54878-.5488-.54878z","fill":"#4a3428"}})])
          )
        }
      }
    